// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerPropertyAddressVerificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerPropertyAddressDetailsDto } from '../..';

interface VerificationParams {
  fullAddress: string;
  propertyTypeCode?: number;
  unit?: string;
}

export const RentalManagerPropertyAddressVerificationWebApiHandler_verification_Path =
  '/api/web/v1/properties/addresses/verification';

/**
 * Validate an address
 */
export const RentalManagerPropertyAddressVerificationWebApiHandler_verification = (
  getParams: VerificationParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<VerificationParams, never, RentalManagerPropertyAddressDetailsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerPropertyAddressVerificationWebApiHandler_verification_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
